import { routes } from "@/helpers";
import { bool, element } from "prop-types";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ authorized = false, children }) => {
  if (!authorized) {
    return <Navigate to={routes.forbidden()} replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  authorized: bool.isRequired,
  children: element.isRequired,
};

export default ProtectedRoute;
